import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import {
  STALE_AFTER_HOURS_OPTIONS,
  StaleAfterHours,
  useStaleAfterHours,
} from "@/hooks/userState/useStaleAfterHours";

/** How far before the period a checklist value stays yellow before it turns red. */
export function StaleAfterHoursSetting() {
  const { t } = useTranslation();
  const { hours, setHours } = useStaleAfterHours();

  return (
    <>
      <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, maxWidth: 320 }}>
        {t("odometerSettings.staleAfterHours")}
      </Typography>
      <RadioGroup
        row
        value={String(hours)}
        onChange={event => setHours(Number(event.target.value) as StaleAfterHours)}
      >
        {STALE_AFTER_HOURS_OPTIONS.map(option => (
          <FormControlLabel
            key={option}
            value={String(option)}
            control={<Radio size="small" />}
            label={option}
          />
        ))}
      </RadioGroup>
    </>
  );
}
